import { useState, useEffect, forwardRef } from 'react';
import ZoomDialog from './ZoomDialog';
import { getImage } from '../services/images.services';
import PulseLoader from './loaders/PulseLoader';
import { useRecoilState } from 'recoil';
import { userAtom } from 'src/atoms/user';
const Image = forwardRef(({ imgKey, height, width, onLoad, alt, disableClick, profile }, ref) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [user, setUser] = useRecoilState(userAtom);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOpen = () => {
    if (disableClick) return;
    setIsDialogOpen(true);
  };

  useEffect(() => {
    // Fetch the image using Axios
    const fetchImage = async () => {
      const imagrUrl = await getImage(imgKey);
      if (profile) {
        setUser({ ...user, profile_picture: imagrUrl });
      }
      setImageUrl(imagrUrl);
    };

    fetchImage();
  }, []);

  return (
    <div>
      <ZoomDialog open={isDialogOpen} onClose={handleDialogClose} imageUrl={imageUrl} />
      {imageUrl ? (
        <img
          src={imageUrl}
          ref={ref}
          alt={alt || 'Image'}
          onClick={handleDialogOpen}
          onLoad={onLoad}
          style={{
            height: height || 'auto',
            width: width || 'auto'
          }}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: height || 'auto',
            width: width || 'auto'
          }}
        >
          <PulseLoader size={10} />
        </div>
      )}
    </div>
  );
});

export default Image;
